<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section class="bg-white text-accent">
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                Deployments
              </div>
              <q-btn
                class="q-ml-md"
                color="primary"
                text-color="white"
                no-caps
                @click="newDialog = true"
                v-if="
                  ['superAdmin', 'appAdmin', 'orgAdmin'].includes(
                    currentUserData.role
                  )
                "
              >
                <q-icon
                  name="mdi-plus-circle"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Add
              </q-btn>
              <q-btn
                class="q-ml-md"
                color="secondary"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-refresh"
                :loading="deploymentsLoading"
                @click="$store.dispatch('deployments/loadAll')"
              >
              </q-btn>
              <q-space />
              <q-input
                style="max-width: 70%"
                filled
                v-model="search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"> </q-icon>
                </template>
              </q-input>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div v-if="deployments">
              <div class="row">
                <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 160px) !important"
                >
                  <datatable
                    :filter="search"
                    :flat="true"
                    :data="deployments"
                    :columns="columns"
                    v-bind:myPagination.sync="pagination"
                    @rowDoubleClick="handleDoubleClick"
                  >
                  </datatable>
                  <div class="row justify-center q-mt-md">
<!--                    <q-pagination-->
<!--                      v-model="pagination.page"-->
<!--                      color="grey-8"-->
<!--                      :max="pagesNumber"-->
<!--                      size="sm"-->
<!--                    />-->
                  </div>
                </div>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
    <q-dialog v-model="newDialog" max-width="600px">
      <q-card v-if="newDialog" tile style="width: 90vw; max-width: 600px">
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              New Deployment
            </div>
            <q-space />
            <q-btn
              color="accent2"
              round
              flat
              icon="mdi-close"
              @click="
                newDialog = false;
                newFormData = {};
              "
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <deploymentForm
            ref="newForm"
            @close="newDialog = false"
            @loadingStateChanged="(state) => (createLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.newForm.create()"
                :loading="createLoading"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-plus-circle"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Add
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="viewDetailsDialog" max-width="600px">
      <q-card
        v-if="viewDetailsDialog"
        tile
        style="width: 90vw; max-width: 600px; min-height: 450px"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">Deployment</div>
            <q-space />
            <q-btn
              color="accent2"
              round
              flat
              icon="mdi-close"
              @click="viewDetailsDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <deploymentForm
            ref="editForm"
            :data="viewFormData"
            @close="viewDetailsDialog = false"
            @loadingStateChanged="(state) => (saveLoading = state)"
          />
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
  import { mapGetters } from "vuex";
  import datatable from "@/components/datatable/datatable.vue";
  import deploymentForm from "@/components/deployments/deploymentForm.vue";
  import moment from "moment";

  // import { Notify } from "quasar";

  export default {
    components: {
      datatable,
      deploymentForm,
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        deployments: "deployments/list",
        deploymentsLoading: "deployments/listLoading",
      }),
      pagesNumber () {
        return Math.ceil(this.deployments.length / this.pagination.rowsPerPage)
      }
    },
    watch: {
      pagination: function(val) {
        console.log(val);
      }
    },
    data: () => ({
      // data-table
      pagination: {
        sortBy: "id",
        descending: true,
      },
      columns: [
        {
          name: "id",
          label: "ID",
          align: "left",
          field: "id",
          sortable: true,
          sortOrder: 'ad',
        },
        {
          name: "name",
          label: "Name",
          align: "left",
          field: "name",
          sortable: true,
        },
        {
          name: "start_ts",
          label: "Start",
          align: "left",
          field: "start_ts",
          sortable: true,
        },
        {
          name: "end_ts",
          label: "End",
          align: "left",
          field: "end_ts",
          sortable: true,
        },
        {
          name: "ownership_id",
          label: "Ownership ID",
          align: "left",
          field: "ownership_id",

          sortable: true,
        },
        {
          name: "devices_id",
          label: "Device ID",
          align: "left",
          field: "devices_id",

          sortable: true,
        },
        {
          name: "organizations_name",
          label: "Org Name",
          align: "left",
          field: "organizations_name",
          sortable: true,
        },
        {
          name: "usersAccessCount",
          label: "Users",
          align: "left",
          field: "usersAccessCount",

          sortable: true,
        },
        {
          name: "eventsCount",
          label: "Events",
          align: "center",
          field: "eventsCount",

          sortable: true,
        },
      ],
      search: "",

      createLoading: false,

      newDialog: false,

      // View and Edit
      viewFormData: {},
      saveLoading: false,
      viewDetailsDialog: false,
    }),
    beforeCreate() {
      this.$store.dispatch("deployments/loadAll");
    },
    mounted() {},
    methods: {
      handleDoubleClick(row) {
        this.viewFormData = row;
        this.viewDetailsDialog = true;
      },
    },
  };
</script>

<style lang="scss">
  .currentlyDeployedTD {
    background: $positive !important;
  }

  .notDeployedTD {
    background: $negative !important;
  }
</style>

<style scoped>
  #depthCard:hover {
    background: #5cb3ff;
    color: white;
  }
</style>
